import classNames from 'classnames';
import { forwardRef, type HTMLAttributes, memo } from 'react';

export type TableRowProps = {
  className?: string;
} & HTMLAttributes<HTMLDivElement>;

export const TableRow = memo(
  forwardRef<HTMLDivElement, TableRowProps>(({ className, ...props }, ref) => (
    <div
      className={classNames('tableRow flex items-center ads:text-metadata text-14 text-gray-10', className)}
      ref={ref}
      {...props}
    />
  )),
);

TableRow.displayName = 'TableRow';
